import { OrganizationKeyName } from "../../../model/Organization";
import { GetProductListActionFilters } from "../model/GetProductListActionFilters";

export const GET_PRODUCT_LIST = "SHOP:GET_PRODUCT_LIST";

export const getProductListAction = (
  organization: OrganizationKeyName,
  filters: GetProductListActionFilters
) => ({
  type: GET_PRODUCT_LIST as typeof GET_PRODUCT_LIST,
  organization,
  filters,
});

export type GetProductListAction = ReturnType<typeof getProductListAction>;
